import "react-toastify/dist/ReactToastify.css";
import type { ReactNode } from "react";
import { ToastContainer } from "react-toastify";
import styles from "./ToastRenderingContainer.module.css";

interface ToastRenderingContainerProps {
  children: ReactNode;
}

const ToastRenderingContainer = ({ children }: ToastRenderingContainerProps) => {
  return (
    <>
      {children}
      <div aria-live="polite">
        <ToastContainer
          position="bottom-left"
          autoClose={3500}
          hideProgressBar
          closeOnClick
          pauseOnHover
          closeButton={false}
          toastClassName={styles.toast}
          className={styles.toastContainer}
        />
      </div>
    </>
  );
};

export default ToastRenderingContainer;
